import React, { Component } from 'react';
import { compose, componentFromProp } from 'recompose';

class ModalWithoutId extends Component {
  constructor(props) {
    super(props);
    this._closeModal = this._closeModal.bind(this);
    this._openModal = this._openModal.bind(this);
  }

  _closeModal() {
    $(this.myModal).modal("hide");
  }

  _openModal() {
    $(this.myModal).modal("show");
  }

  componentDidMount() {
    const {
      closeCallback
    } = this.props;

    if (this.props.open) {
      this._openModal();
    }
    if (typeof closeCallback === 'function') {
      $(this.myModal).on('hidden.bs.modal', (e) => {
        closeCallback();
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.open) {
      this._openModal();
    } else {
      this._closeModal();
    }
  }

  render() {
    return (
      <div ref={(modal) => { this.myModal = modal; }}
        className="modal fade" role="dialog" aria-hidden="true">
        <div
          className={this.props.size ? `modal-dialog modal-${this.props.size}` : "modal-dialog"}
          role="document"
        >
          {this.props.open && this.props.children}
        </div>
      </div>
    )
  }
}

export const willShowModal = (modalProps = {}) => {
  return (WrappedComponent) => {
    return class WillShowModal extends Component {
      constructor(props) {
        super(props);
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
      }

      state = {
        showModal: false
      }

      closeModal() {
        this.setState({ showModal: false });
      }

      openModal() {
        this.setState({ showModal: true });
      }

      render() {
        const { showModal } = this.state;
        return (
          <span>
              <span onClick={this.props.disabled ? e => (e.preventDefault()) : this.openModal}>
                <WrappedComponent {...this.props}/>
              </span>
            {
              <ModalWithoutId
                closeCallback={this.closeModal}
                open={showModal} {...modalProps}>
                {this.props.children(this.closeModal)}
              </ModalWithoutId>
            }
          </span>
        );
      }
    }
  };
};

const ModalBody = componentFromProp('modalBody');
export const withModal = WrappedComponent => props =>
  <span>
    <WrappedComponent {...props}/>
    <ModalWithoutId
      size={props.size}
      closeCallback={props.closeCallback}
      open={props.open}>
      <div className='modal-content message-content text-center'>
        <div className='modal-header justify-content-end pb-0'>
          <button type='button' className='close' data-dismiss='modal' aria-label='Close'>
            <span aria-hidden='true'>&times;</span>
          </button>
        </div>
        <div className='modal-body'>
          <ModalBody {...props}/>
        </div>
      </div>;
    </ModalWithoutId>
  </span>;

export default ModalWithoutId;



// WEBPACK FOOTER //
// ./src/Common/Modal/Modal.js